<template>
  <div
    class="page-menu"
    :class="{ 'highlight-matched-route': !highlightExactRoute }"
  >
    <div v-for="menuItem in menu" :key="menuItem._id">
      <div class="page-menu-category" v-if="menuItem.type == 'category'">
        <label>{{ menuItem.name }}</label>
        <!-- START: Group Fields -->
        <PageSubMenu :menu="menuItem.menuItems"></PageSubMenu>
        <!-- END: Group Fields -->
      </div>
      <router-link
        v-else
        class="page-menu-item"
        :to="menuItem.path"
        @click="menuClicked(menuItem)"
      >
        <unicon v-if="menuItem.icon" :name="menuItem.icon"></unicon>
        <span>{{ menuItem.name }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideMenu",
  props: {
    menu: {
      type: Array,
      required: true,
    },
    highlightExactRoute: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    PageSubMenu: () => import("./SideMenu.vue"),
  },
  methods: {
    menuClicked(item) {
      this.$emit("menuClicked", item);
    },
  },
};
</script>

<style scoped lang="scss">
.page-menu-category {
  margin-bottom: 2.5rem;

  label {
    display: block;
    color: lighten($paragraphColor, 15%);
    font-weight: $mediumFontWeight;
    font-size: $smallestFontSize;
    margin-bottom: 1rem;
  }
}

.page-menu {
  flex: 1;
}

.page-menu-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.45rem 0.85rem;
  margin-bottom: 0.15rem;
  border-radius: 0.35rem;
  cursor: pointer;
  @include transition;

  span {
    font-size: $smallFontSize;
    line-height: auto;
    color: $greyColor;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .unicon ::v-deep {
    svg {
      fill: lighten($greyColor, 40%);
      height: auto;
      width: 1rem;
      margin-right: 0.75rem;
    }
  }

  &:hover {
    background-color: lighten($lightGreyColor, 30%);
    text-decoration: none;
  }
  &.router-link-exact-active {
    background-color: lighten($lightGreyColor, 30%);
    span {
      font-weight: $mediumFontWeight;
    }
  }
}

.highlight-matched-route {
  .router-link-active {
    background-color: lighten($lightGreyColor, 30%);
    span {
      font-weight: $mediumFontWeight;
    }
  }
}
</style>
